import React, { Suspense } from "react";
import Slider from "components/slider";
//import "./event.scss";


const TipsCard = (props) => {

    const { header, tips } = props;
    const cards = tips.map((tip, index) => <div key={index} className="tip-details"><p>{tip}</p></div>);

    return (
        <div className="tips-wrapper" style={{ width: "100%" }}>
            <Suspense fallback={<div>Loading Tips...</div>}>
                <Slider
                    data={cards}
                    cardClass="tip-card"
                    has_header={true}
                    header={header}
                    numSlides={1.3}
                    style={`carousel carousel--tips ${cards?.length === 1
                        ? "hide-swipper-buttons"
                        : ""
                    }`} />
            </Suspense>
        </div>
    );
};

export default TipsCard;
